import * as React from "react";
import { Squash } from "hamburger-react";
import { Box } from "../../atoms";

export type BurgerProps = React.ComponentProps<typeof Box> & {
  isOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
} & React.HTMLAttributes<HTMLSpanElement>;

const Burger: React.FC<BurgerProps> = ({ isOpen, onToggle, ...props }) => {
  return (
    <Box as="span" {...props}>
      <Squash toggled={isOpen} onToggle={onToggle} />
    </Box>
  );
};

export { Burger };
